import React from 'react'
import './LabelValueRaw.scss'

const LabelValueRaw = ({label, value}) => (
  <div className="label-value">
    <div className="label">{label}:</div>
    <div className="value">{value}</div>
  </div>
)

export default LabelValueRaw
